import { Component } from '@angular/core';
import { ConfigurationListComponent } from './configuration-list.component';

@Component({
    template: '<app-configuration-list [isAdmin]="false"></app-configuration-list>',
    imports: [ConfigurationListComponent],
})
export class ConfigurationCustomerWrapperComponent {
}
